// ISSNNumberRegistration.jsx
import React from "react";

export default function ISSNNumberRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISSN Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISSN Number Registration for Journals &amp; Serials
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists publishers in obtaining ISSN
            registration for periodicals and journals, helping align
            applications with the requirements of the ISSN National Centre.[web:251][web:255]
          </p>
          <p className="text-gray-700">
            The support covers collating publication data, preparing
            documentation, and guiding on sample issues or URLs so that serials
            can secure a globally recognisable ISSN identifier.[web:251][web:252][web:254]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/159711/books-book-pages-read-literature-159711.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Stack of journals and periodicals representing ISSN registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISSN Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps publishers prepare the publication and
              identity details that are typically requested when applying for an
              ISSN.[web:251][web:252][web:255]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Publication details including title, subtitle if any,
                  frequency, language, medium (print/online), subject focus, and
                  country of publication.[web:249][web:251][web:255]
                </li>
                <li>
                  Publisher identity proof and contact details, such as name of
                  the organization or individual, address, email, and basic
                  registration/KYC where applicable.[web:251][web:252]
                </li>
                <li>
                  Sample copy or website link: at least one published issue for
                  print journals, or an active website with several issues
                  online in case of e‑journals.[web:249][web:251][web:261]
                </li>
                <li>
                  Any additional declarations or forms required by the ISSN
                  National Centre (for example, confirmation of periodicity and
                  editorial responsibility).[web:249][web:255]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm’s role is to simplify ISSN applications for publishers,
              especially new or small journals that may be unfamiliar with the
              process.[web:251][web:253]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Publishing Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on aligning publication structure, periodicity, and
                  basic metadata with ISSN guidelines to improve acceptance of
                  applications.[web:249][web:251][web:255]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Application Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in completing forms and attaching correct samples
                  or URLs so that submissions are clear and minimize back‑and‑forth
                  queries.[web:251][web:252]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Continued support from planning the ISSN request to tracking
                  application status and updating publication details when
                  required.[web:251][web:253]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
